import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { getEncodeData } from '../../services/user'
import './VerifyAccount.css'
import { reloadPage } from '../../utils'

const VerifyAccount = () => {
  const { token } = useParams()

  useEffect(() => {
    const verify = async () => {
      const decodedToken = token?.replace(/!/g, '.')

      localStorage.setItem('token', JSON.stringify({ token: decodedToken }))

      await getEncodeData(decodedToken)
      await reloadPage()
    }

    verify()
  }, [])

  return (
    <div className="verify-account__container">
      <div className="verify-account__card">
        <div className="verify-account__icon-skeleton" />

        <div className="verify-account__title-skeleton" />

        <p className="verify-account__text">Verificando...</p>

        <div className="verify-account__bars">
          <div className="verify-account__bar verify-account__bar--long" />
          <div className="verify-account__bar verify-account__bar--medium" />
          <div className="verify-account__bar verify-account__bar--short" />
        </div>

        <div className="verify-account__dots">
          <span className="verify-account__dot" />
          <span className="verify-account__dot" />
          <span className="verify-account__dot" />
        </div>
      </div>
    </div>
  )
}

export default VerifyAccount
